import { render } from "./ReceiptCheckStatus.vue?vue&type=template&id=de088d48&scoped=true&ts=true"
import script from "./ReceiptCheckStatus.vue?vue&type=script&lang=ts"
export * from "./ReceiptCheckStatus.vue?vue&type=script&lang=ts"

import "./ReceiptCheckStatus.vue?vue&type=style&index=0&id=de088d48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de088d48"]])

export default __exports__